import { render, staticRenderFns } from "./seminarlist.vue?vue&type=template&id=5980b398&scoped=true&"
import script from "./seminarlist.vue?vue&type=script&lang=js&"
export * from "./seminarlist.vue?vue&type=script&lang=js&"
import style0 from "./seminarlist.vue?vue&type=style&index=0&id=5980b398&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5980b398",
  null
  
)

export default component.exports